import React from 'react';
import { Heading } from '@americanexpress/dls-react';

const HomePage = () => (
  <>
    <Heading level={1} variant="sans-xlarge-book" className="margin-2-b">
      Hotel Vendor Comparison
    </Heading>
    <ul className="list margin-2-t">
      <li className="pad-1-b">
        <a href="/nuitee/details">Nuitee</a>
      </li>
      <li className="pad-1-b">
        <a href="/lxp/details">LXP (Expedia)</a>
      </li>
      <li className="pad-1-b">
        <a href="/spotnana/details">Spotnana</a>
      </li>
    </ul>
  </>
);

export default HomePage;
